import React from 'react';
import PropTypes from 'prop-types';
import PasswordField from "./password_field";
import Field from "./field";
import ActionButton from "./action_button";

const SignOps = props => (
  <form className="form">
    <Field id="username" label="Username" value={props.username} handleChange={props.handleChange}/>
    <PasswordField onChange={props.handleChange} password={props.password}/>
    {
      props.showForgotPassword
      ? (
          <PasswordField id="new_password" label="New Password" onChange={props.handleChange} password={props.new_password}/>
      ) : null
    }

    <div id="actions">
      <ActionButton onClick={props.onSignup} text="Sign Up"/>
      <ActionButton onClick={props.onSignin} text="Sign In"/>
      <ActionButton onClick={props.onForgotPassword} text="Forgot Password"/>
      <ActionButton onClick={props.onChangePassword} text="Change Password" show={props.showForgotPassword}/>
      <ActionButton onClick={props.onResendCode} text="Resend Code"/>
    </div>
  </form>
);

SignOps.propTypes = {
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  new_password: PropTypes.string.isRequired,
  showForgotPassword: PropTypes.bool.isRequired,
  onSignup: PropTypes.func.isRequired,
  onSignin: PropTypes.func.isRequired,
  onForgotPassword: PropTypes.func.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  onResendCode: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default SignOps;